import React from 'react';
import log from 'loglevel';
import { AlertBanner, ArrowLink } from '../../../ui';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function onClickClose(e: any) {
	log.debug(e);
}

export const AlertBanners = () => (
	<AlertBanner
		title="Hurricane alert"
		closeLabel="Close"
		onClickClose={onClickClose}
	>
		<p>
			Due to impact of hurricane Michael some flights have been cancelled.
			Please check your flight status on the flight list or in the CLT Airport
			app.
		</p>
		<ArrowLink
			href="http://www.google.com/search?q=hurricane+Michael"
			target="_blank"
			rel="noopener"
		>
			Read more
		</ArrowLink>
	</AlertBanner>
);
